import { TagsInput } from "../../fields/tags-input";
import { Tags } from "../../tags";

export function CellTags<T extends object>(props: {
  item: T;
  attr: keyof T;
  patch?: any;
  copyable?: boolean;
}) {
  if (props.patch) {
    return <TagsInput attr={props.attr} model={props.patch} />;
  }

  return (
    <Tags tags={props.item[props.attr] as string[]} copyable={props.copyable} />
  );
}
